import React, { useState, useEffect } from "react";
import { Column, DataGrid, Button } from "devextreme-react/data-grid";
import { api_path } from "../../shared";
import CustomStore from "devextreme/data/custom_store";
const CustomerSalesIncharge = ({ SMF_CODE, CUSTOMER_NAME }) => {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = api_path + "/customer/last-shipment.php";
  const [detailDataSource, setDetailDataSource] = useState(null);
  useEffect(() => {
    if (SMF_CODE) {
      console.log("Fetch URL:", `${url}?customer_code=${SMF_CODE}`);
      const store = new CustomStore({
        key: "DOCNO",
        load: () => {
          return fetch(`${url}?customer_code=${SMF_CODE}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .catch((error) => {
              console.error("Error loading data:", error);
              return [];
            });
        },
      });
      setDetailDataSource(store);
    }
  }, [SMF_CODE]);

  return (
    <div className="">
      <br />
      <div className="headSubject">
        Last 10 Shipments of The Customer (By SMF Code)
      </div>
      <DataGrid
        dataSource={detailDataSource}
        showBorders={false}
        keyExpr="DOCNO"
      >
        <Column dataField="DOCNO"  width={100}/>
        <Column dataField="JOBNO" width={100}/>
        <Column dataField="SALENAME" caption="Sales" width={200}/>
        <Column dataField="EXPORTER" caption="Customer"  width={100}/>
        <Column dataField="EXPORTERNAME" caption="Exporter" />
        <Column dataField="CHGTERM" width={50} />
        <Column dataField="LOADPORT" caption="POL" width={100} />
        <Column dataField="DISPORT" caption="POD" width={100} />
        <Column dataField="DELPORT" caption="DEL" width={100} />
        <Column
          dataField="ETDETA"
          caption="ETD/ETA"
          dataType="datetime"
          format="dd-MMM-yyyy"
        />
        <Column dataField="SINO_BU" caption="BU" width={100} />
      </DataGrid>
    </div>
  );
};

export default CustomerSalesIncharge;
